import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';

//Servicios
import { ViniedoService } from '../../services/api';

//Componentes
import Vineyards from './VineyardList';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import Spinner from '../../components/spinner/Spinner';

function VineyardsListContainer() {
    const { token, user, viniedos } = useGlobalContext();
    const formMethods = useForm();

    const [loader, setLoader] = useState(false);

    const Navigate = useNavigate();

    useEffect(() => {
        const getMyVineyards = async () => {
            try {
                setLoader(true);

                const myVineyards = await ViniedoService.all({
                    token,
                    usuarioId: user.id,
                });

                if (myVineyards.data.length === 1 && user.tipo !== 3) {
                    Navigate(
                        RoutesApp.Viniedos.single + myVineyards.data[0].id
                    );
                }

                if (myVineyards.data.length > 1) {
                    setTableData(buildTableData(myVineyards.data));
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        if (user.id !== 3) getMyVineyards();
    }, []);

    const buildTableData = (data = [{ id: 1, num: '' }]) => {
        return {
            title: 'Mis Viñedos',
            headers: ['Viñedo', ' '],
            pagination: 10,
            data: data?.map((v) => {
                return {
                    viniedo: v.num,
                    icons: (
                        <div>
                            <Link
                                to={RoutesApp.Viniedos.single + v.id}
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={right_arrow}
                                    title="Visualizar"
                                    alt="Visualizar"
                                />
                            </Link>
                        </div>
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? (
        <Spinner />
    ) : (
        <Vineyards
            functions={{ ...formMethods }}
            states={{ user, viniedos, tableData }}
        />
    );
}

export default VineyardsListContainer;
